import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    position: relative;
`;
const ColoredTop = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 35vh;
    background-color: #ff575c;
    display: flex;
    justify-content: center;
`;
const WhiteBottom = styled.div`
    position: absolute;
    top: 25vh;
    left: -150vw;
    height: 400vw;
    width: 400vw;
    background-color: white;
    border-radius: 50%;
`;
const Title = styled.h3`
    z-index: 1;
    font-size: 2em;
    position: fixed;
    color: white;
`;

const Image = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    padding-bottom: 11vh;
`;

const ChildrenContainer = styled.div`
    margin-top: 28vh;
    padding-top: 2vh;
    height: 70vh;
    width: 100%;
    position: sticky;
    top: 0em;
`;

interface Props {
    children?: React.ReactNode;
}

const LoginLayout = (props: Props) => {
    return (
        <Container>
            <ColoredTop>
                <Image src="/static/login-image.png" />
            </ColoredTop>
            <WhiteBottom />
            {/** <Title>Thoughtfully</Title> **/}
            <ChildrenContainer>{props.children}</ChildrenContainer>
        </Container>
    );
};

export default LoginLayout;
